import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { openModal } from '@/services/modalsProvider';
import {
  MODAL_NAMES,
  DOCUMENT_MODAL_TYPES,
  DOCUMENT_URL_PARAM_KEY,
} from '@/utils/constants';

const openDocumentModal = (documentType) => {
  openModal({
    id: documentType,
    modalName: MODAL_NAMES.document,
    props: {
      docType: documentType,
    },
  });
};

const useDocumentUrlHandler = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const documentType = searchParams.get(DOCUMENT_URL_PARAM_KEY);
  const isValidDocumentType = Boolean(DOCUMENT_MODAL_TYPES[documentType]);

  const removeDocumentParam = () => {
    const newSearchParams = new URLSearchParams(searchParams);

    newSearchParams.delete(DOCUMENT_URL_PARAM_KEY);
    setSearchParams(newSearchParams);
  };

  useEffect(() => {
    if (documentType && isValidDocumentType) {
      openDocumentModal(documentType);
      removeDocumentParam();
    }
  }, [documentType, searchParams, setSearchParams]);

  return null;
};

export default useDocumentUrlHandler;
